// Helpers para o Azure File Share `dados` em devlnxstoragellm
// (montado em L:\ no Windows como SMB; aqui acessamos via REST do File Service).
//
// Layout:
//   <BASE_URL>/<filename>/current_<engine>.txt
//   <BASE_URL>/<filename>/speakers.json
//   <BASE_URL>/<filename>/principal/<filename>(_provider).txt   (auditoria)
//   <BASE_URL>/<filename>/backup/<filename>(_provider).txt
//
// Read é um GET simples (igual ao Blob).
// Write em Azure Files é em 2 etapas: PUT cria o arquivo com tamanho, PUT ?comp=range escreve os bytes.

const BASE_URL = process.env.REACT_APP_FILESHARE_BASE_URL;
const SAS = process.env.REACT_APP_TOKEN_FILES_LLM;

const _sas = () => (SAS?.startsWith("?") ? SAS : `?${SAS || ""}`);

export const fileShareUrl = (relPath, { cacheBust = false } = {}) => {
  const sas = _sas();
  const t = cacheBust ? `&t=${Date.now()}` : "";
  return `${BASE_URL}/${relPath}${sas}${t}`;
};

export const getFileShareText = async (relPath) => {
  const res = await fetch(fileShareUrl(relPath, { cacheBust: true }), {
    cache: "no-store",
  });
  if (!res.ok) throw new Error(`GET ${relPath} → HTTP ${res.status}`);
  return res.text();
};

export const headFileShare = async (relPath) => {
  const res = await fetch(fileShareUrl(relPath, { cacheBust: true }), {
    method: "HEAD",
  });
  if (!res.ok) throw new Error(`HEAD ${relPath} → HTTP ${res.status}`);
  return {
    lastModified: res.headers.get("Last-Modified"),
    contentLength: Number(res.headers.get("Content-Length") || 0),
  };
};

// Azure Files: PUT em 2 etapas.
// 1) Cria o arquivo (sem corpo) anunciando x-ms-content-length.
// 2) Escreve os bytes via PUT ?comp=range com x-ms-range e x-ms-write=update.
export const putFileShareText = async (
  relPath,
  text,
  contentType = "text/plain; charset=utf-8"
) => {
  const bytes = new TextEncoder().encode(text);
  const len = bytes.byteLength;
  const baseUrl = fileShareUrl(relPath);

  const createRes = await fetch(baseUrl, {
    method: "PUT",
    headers: {
      "x-ms-type": "file",
      "x-ms-content-length": String(len),
      "x-ms-content-type": contentType,
    },
  });
  if (!createRes.ok) {
    throw new Error(`Create file ${relPath} → HTTP ${createRes.status}`);
  }

  if (len === 0) return;

  const sep = baseUrl.includes("?") ? "&" : "?";
  const rangeUrl = `${baseUrl}${sep}comp=range`;
  const writeRes = await fetch(rangeUrl, {
    method: "PUT",
    headers: {
      "x-ms-range": `bytes=0-${len - 1}`,
      "x-ms-write": "update",
      "Content-Type": "application/octet-stream",
    },
    body: bytes,
  });
  if (!writeRes.ok) {
    throw new Error(`Write range ${relPath} → HTTP ${writeRes.status}`);
  }
};

export const putFileShareJson = async (relPath, obj) =>
  putFileShareText(
    relPath,
    JSON.stringify(obj, null, 2),
    "application/json; charset=utf-8"
  );
